module.exports = __webpack_public_path__ + "img/ghb.64df201a.svg";